var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('the-create',{attrs:{"companyId":_vm.companyId,"productId":_vm.productId,"projectId":_vm.projectId,"editType":3,"read-published":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }